import { Action } from 'redux';

import { File } from '@models';

import { RequestStatus } from './request';

export const GOT_FILES = 'GOT_FILES';
export const GETTING_FILES = 'GETTING_FILES';

export interface IFilesAction extends Action {
  payload: File[];
}

export type FilesActionType = Action | IFilesAction;

export interface IFileState {
  files: File[];
  status: RequestStatus;
}
